<!-- TODO: this component needs to be refactored - split on several child components based on viewMode -->
<!-- TODO: <div class="card-body" ...> section needs to be separated in it's own component as well -->
<ng-container *ngIf="viewMode == 'default' && !isStoryMode">
  <div #galleryContainer></div>

  <div
    class="post-card"
    #card
    [class.has-custom-bg]="!!backgroundColor"
    [style.--post-bg]="backgroundColor || null"
    [style.--post-fg]="foregroundColor"
    [ngClass]="{
      selected: post.selected,
      highlighted: highlighted,
      parent: post.is_parent,
      collapsed: post.is_collapsed,
    }"
  >
    <!-- Context label: shown on parent posts in threads mode -->
    <div class="thread-context-label" *ngIf="showThreads && post.is_parent">
      <fa-icon [icon]="['fas', 'quote-left']"></fa-icon>
      <span>{{ "post-card.label.thread-context" | translate }}</span>
    </div>

    <!-- Reply indicator: shown on child posts in threads mode -->
    <div
      class="thread-reply-indicator"
      *ngIf="showThreads && post.has_parent_thread && !post.is_parent"
    >
      <fa-icon [icon]="['fas', 'reply']"></fa-icon>
      <span>{{ "post-card.label.matched-reply" | translate }}</span>
    </div>

    <div class="card-header">
      <div class="card-info">
        <div
          class="select-tool"
          (click)="togglePostSelect()"
          *ngIf="isSelectable"
        >
          <sui-checkbox [checked]="post.selected"></sui-checkbox>
        </div>
        <div class="post-type" *ngIf="post.icon">
          <fa-icon [icon]="post.icon"></fa-icon>
        </div>

        <!-- Take sentiment_id from the first element in post_sentiment_algorithm_list and use it as div class for sentiment
        sentiment_id 1 is neutral, 2 is positive, 3 is negative
        for text, use the "title" from the first element in post_sentiment_algorithm_list -->

        <div
          *ngIf="
            postToolsConfig['sentiment'] &&
            post.post_sentiment_algorithm_list[0] as sentiment
          "
          [class.disabled]="disableTools"
        >
          <div
            [suiMenuTrigger]="sentimentMenu1"
            [suiMenuTriggerDisabled]="isShadow"
            class="sentiment {{
              sentimentClassMap[
                post.post_sentiment_algorithm_list[0].sentiment_id
              ] ?? 'neutral'
            }}"
          >
            {{ post.post_sentiment_algorithm_list[0].title }}

            <div
              class="sentiment-tag-changed"
              [class.neutral]="
                post.sentiment_value_original.id == NomSentiment.NEUTRAL
              "
              [class.positive]="
                post.sentiment_value_original.id == NomSentiment.POSITIVE
              "
              [class.negative]="
                post.sentiment_value_original.id == NomSentiment.NEGATIVE
              "
              *ngIf="
                userFacade.hasPermissionSync(
                  AppComponents.FEED_SEARCH_RESULTS_DISPLAY_SENTIMENT_IS_MODIFIED
                ) &&
                sentiment.is_default &&
                post.sentiment_value_original.id
              "
              [suiTooltip]="post.sentiment_value_original.text"
            >
              <fa-icon [icon]="['fas', 'exclamation-circle']"></fa-icon>
            </div>
          </div>
          <ng-template #sentimentMenu1>
            <sui-menu>
              <button
                sui-menu-item
                (click)="setSentiment(NomSentiment.NEGATIVE)"
              >
                <fa-icon [icon]="['fas', 'face-frown']"></fa-icon>
                <span>{{
                  "post-card.dropdown-item.negative" | translate
                }}</span>
              </button>
              <button
                sui-menu-item
                (click)="setSentiment(NomSentiment.NEUTRAL)"
              >
                <fa-icon [icon]="['fas', 'face-meh']"></fa-icon>
                <span>{{ "post-card.dropdown-item.neutral" | translate }}</span>
              </button>
              <button
                sui-menu-item
                (click)="setSentiment(NomSentiment.POSITIVE)"
              >
                <fa-icon [icon]="['fas', 'smile']"></fa-icon>
                <span>{{
                  "post-card.dropdown-item.positive" | translate
                }}</span>
              </button>
            </sui-menu>
          </ng-template>
        </div>
        <div
          class="post-date"
          *ngIf="postToolsConfig['post_time_published_relative']"
        >
          {{ post.publish_time.relative }}
        </div>
        <div
          class="post-date"
          *ngIf="postToolsConfig['post_time_published_absolute']"
        >
          {{ post.publish_time.absolute | date: "dd.MM.yyyy HH:mm" }}
        </div>
        <div
          class="post-date"
          *ngIf="postToolsConfig['post_time_created_relative']"
        >
          {{ post.created_time.relative }}
        </div>
        <div
          class="post-date"
          *ngIf="postToolsConfig['post_time_created_absolute']"
        >
          {{ post.created_time.absolute | date: "dd.MM.yyyy HH:mm" }}
        </div>
        <a [href]="post.url" target="_blank">
          <fa-icon [icon]="['fas', 'arrow-up-right-from-square']"></fa-icon>
        </a>
        <div
          class="completeness-score"
          [class.low]="post.completeness_score <= 25"
          [class.medium]="
            post.completeness_score > 25 && post.completeness_score <= 75
          "
          [class.high]="post.completeness_score > 75"
          *ngIf="user?.access_level_id >= UserAccessLevel.GLOBAL_ADMIN"
        >
          <fa-icon [icon]="scoreIcon"></fa-icon>
          <span>{{ post.completeness_score }}</span>
        </div>
        <div
          class="has-synopsis"
          *ngIf="
            post.has_synopsis &&
            userFacade.hasPermissionSync(
              AppComponents.POST_DETAILS_PANE_SYNOPSIS_EDITOR
            )
          "
          [suiTooltip]="'post-card.tooltip.has-synopsis' | translate"
        >
          <fa-icon [icon]="['fas', 'clipboard-list']"></fa-icon>
        </div>
        <div
          class="has-trancription"
          *ngIf="post.has_transcription"
          [suiTooltip]="'post-card.tooltip.has-transcription' | translate"
        >
          <fa-icon [icon]="['fas', 'message']"></fa-icon>
        </div>
        <div
          class="has-translation"
          *ngIf="post.has_translation"
          [suiTooltip]="'post-card.tooltip.has-transcription' | translate"
        >
          <fa-icon [icon]="['fas', 'language']"></fa-icon>
        </div>
        <div
          class="has-screen-capture"
          *ngIf="hasScreenCapture"
          [suiTooltip]="'post-card.tooltip.has-screen-capture' | translate"
        >
          <fa-icon [icon]="['fas', 'camera']"></fa-icon>
        </div>
      </div>

      <div class="card-tools">
        <div
          class="card-tool"
          *ngIf="!disableTools && postToolsConfig['view-details']"
        >
          <a
            [suiTooltip]="'post-card.tooltip.view-details' | translate"
            (click)="toggleDetails()"
            ><fa-icon [icon]="['fas', 'eye']"></fa-icon
          ></a>
        </div>

        <div
          class="card-tool"
          *ngIf="
            postToolsConfig['edit-categories'] && !disableTools && !isShadow
          "
        >
          <a
            [suiTooltip]="'post-card.tooltip.edit-categories' | translate"
            (click)="editCategories()"
            ><fa-icon [icon]="['fas', 'tag']"></fa-icon
          ></a>
        </div>
        <div
          class="card-tool"
          *ngIf="
            postToolsConfig['edit-sentiment'] && !disableTools && !isShadow
          "
        >
          <a
            [suiTooltip]="'post-card.tooltip.edit-sentiment' | translate"
            (click)="editSentiment()"
            ><fa-icon [icon]="['far', 'face-smile']"></fa-icon
          ></a>
        </div>
        <div
          class="card-tool"
          *ngIf="postToolsConfig['edit-related'] && !disableTools && !isShadow"
        >
          <a
            [suiTooltip]="'post-card.tooltip.link-related-articles' | translate"
            (click)="editRelated()"
            ><fa-icon [icon]="['fas', 'chain']"></fa-icon
          ></a>
        </div>
        <div
          class="card-tool"
          *ngIf="postToolsConfig['share'] && !disableTools"
        >
          <a
            [suiTooltip]="'post-card.tooltip.share' | translate"
            (click)="sharePost()"
            ><fa-icon [icon]="['fas', 'share']"></fa-icon
          ></a>
        </div>
        <div class="card-tool" *ngIf="postToolsConfig['debug']">
          <a
            [suiTooltip]="'post-card.tooltip.debug' | translate"
            target="_blank"
            href="{{ debugUrl }}"
            ><fa-icon [icon]="['fas', 'bug']"></fa-icon
          ></a>
        </div>
        <div
          class="card-tool"
          *ngIf="postToolsConfig['translate'] && !disableTools"
        >
          <a
            [suiTooltip]="'post-card.tooltip.translate' | translate"
            [href]="translateUrl"
            target="_blank"
            ><fa-icon [icon]="['fas', 'language']"></fa-icon
          ></a>
        </div>

        <div class="card-tool" *ngIf="!disableTools && user && !isShadow">
          <sui-button
            size="sm"
            variant="ghost"
            [leadingIcon]="['fas', 'bars']"
            [trailingIcon]="['fas', 'caret-down']"
            [iconOnly]="true"
            ariaLabel="Algorithms"
            [expanded]="postAlgorithmsRef.isOpen()"
            [suiMenuTrigger]="algorithmsMenu1"
            #postAlgorithmsRef="suiMenu"
          ></sui-button>
          <ng-template #algorithmsMenu1>
            <sui-menu>
              <ng-container *ngFor="let item of algorithms; let i = index">
                <sui-menu-separator
                  *ngIf="
                    i > 0 && algorithms[i].group !== algorithms[i - 1].group
                  "
                ></sui-menu-separator>
                <button sui-menu-item (click)="runAlgorithm(item)">
                  <fa-icon *ngIf="item.icon" [icon]="item.icon"></fa-icon>
                  <span>{{ item?.name }}</span>
                </button>
              </ng-container>
            </sui-menu>
          </ng-template>
        </div>
        <div
          *ngIf="loadingAlgorithmPostIds?.includes(post.id)"
          class="loading-post-algorithm"
        >
          <fa-icon [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
        </div>
        <div
          *ngIf="appliedAlgorithmPostIds?.includes(post.id)"
          class="applied-post-algorithm"
          [suiTooltip]="'post-card.tooltip.applied-algorithm' | translate"
        >
          <fa-icon [icon]="['fas', 'square-check']"></fa-icon>
        </div>
        <div
          class="card-tool remove-post"
          *ngIf="
            removable &&
            userFacade.hasPermissionSync(
              AppComponents.FEED_SEARCH_RESULTS_REMOVE_CONTENT_FROM_FEED
            ) &&
            !disableTools &&
            !isShadow
          "
        >
          <a
            [suiTooltip]="'post-card.tooltip.remove-post' | translate"
            (click)="removeFromFeed()"
            ><fa-icon [icon]="['far', 'times-circle']"></fa-icon
          ></a>
        </div>
        <div class="card-tool remove-post" *ngIf="customRemovePost">
          <a
            [suiTooltip]="'post-card.tooltip.remove-post' | translate"
            (click)="customRemovePost(post); $event.stopPropagation()"
            ><fa-icon [icon]="['far', 'times-circle']"></fa-icon
          ></a>
        </div>
      </div>
    </div>

    <div class="card-body" (click)="togglePostSelect()">
      <div class="author" *ngIf="post.type === 'social'">
        <div class="avatar" *ngIf="post.author?.avatar_url">
          <a
            *ngIf="post.author.profile_url"
            [href]="post.author.profile_url"
            target="_blank"
          >
            <img
              [src]="post.author.avatar_url"
              [appFallbackImage]="avatarFallback"
              appLazyLoad
              class="post-avatar"
            />
          </a>
          <img
            *ngIf="!post.author.profile_url"
            [src]="post.author.avatar_url"
            [appFallbackImage]="avatarFallback"
            appLazyLoad
            class="post-avatar"
          />
        </div>
      </div>
      <a
        [href]="post.type === 'social' ? post.url : null"
        target="_blank"
        (click)="$event.stopPropagation()"
        class="thumbnail"
        *ngIf="post.thumbnail && postToolsConfig['thumbnail']"
      >
        <img
          [src]="post.thumbnail"
          appFallbackImage
          [loadingImage]="loadingImage"
          [containerLevelsUp]="1"
          appLazyLoad
          class="post-thumbnail"
        />
      </a>
      <div class="card-content">
        <div
          class="author-info"
          *ngIf="post.type === 'social' && post.author as author"
        >
          <!-- Author Name -->
          <a
            *ngIf="author.profile_url"
            [href]="author.profile_url"
            target="_blank"
            class="author-name"
          >
            {{ author.name }}
          </a>
          <span *ngIf="!author.profile_url" class="author-name">
            {{ author.name }}
          </span>

          <!-- Author Handle -->
          <ng-container *ngIf="author.username">
            <a
              *ngIf="author.profile_url"
              [href]="author.profile_url"
              target="_blank"
              class="author-handle"
            >
              {{ "@" + author.username }}
            </a>
            <span *ngIf="!author.profile_url" class="author-handle">
              {{ "@" + author.username }}
            </span>
          </ng-container>
        </div>
        <a
          class="title"
          [innerHTML]="post.title"
          [href]="post.url"
          target="_blank"
          (click)="$event.stopPropagation()"
        ></a>
        <a
          [attr.href]="post.type === 'social' ? post.url : null"
          target="_blank"
          (click)="onContentClick($event)"
          class="content"
          [innerHTML]="post.content"
          *ngIf="postPropertyConfig['content']"
        ></a>
        <div class="user-categories" *ngIf="post.user_categories.length > 0">
          <span class="categories-title">{{
            "post-card.label.categories" | translate
          }}</span>
          <span
            class="user-category"
            *ngFor="let category of post.user_categories; trackBy: trackById"
            (click)="editCategories()"
          >
            <fa-icon [icon]="['fas', 'tag']"></fa-icon>
            {{ category.name }}</span
          >
        </div>
        <div
          class="workflows"
          *ngIf="
            userFacade.hasPermissionSync(
              AppComponents.FEED_SEARCH_RESULTS_EDIT_WORKFLOW
            ) && workflowStages?.length > 0
          "
        >
          <span class="workflows-title">{{
            "post-card.label.workflows" | translate
          }}</span>
          <div
            *ngFor="let stage of workflowStages"
            class="workflow-stage"
            [ngClass]="{
              active: stage.is_current,
              clickable: stage.enabled && !isShadow,
            }"
            (click)="
              stage.enabled && !isShadow ? changeWorkflowStage(stage) : null
            "
          >
            <fa-icon
              [icon]="['fas', 'backward-step']"
              *ngIf="stage.is_previous"
            ></fa-icon>
            {{ stage.name }}
            <fa-icon
              [icon]="['fas', 'forward-step']"
              *ngIf="stage.is_next"
            ></fa-icon>
          </div>
        </div>
      </div>
    </div>
    <div class="attachments" *ngIf="post.attachments?.length > 0">
      <ng-container *ngFor="let attachment of post.attachments; let i = index">
        <div
          *ngIf="!(attachment.is_thumbnail && attachment.type == 'image')"
          class="attachment

        {{ attachment.type }}"
        >
          <ng-container [ngSwitch]="attachment.type">
            <!-- Video Attachment -->
            <ng-container *ngSwitchCase="'video'">
              <app-video-player
                [attachment]="attachment"
                [postId]="post.id"
                [attachmentId]="post.id + '-' + i"
                [postTypeId]="post.post_type_id"
                [contentProviderId]="post.content_provider.id"
                [autoplay]="false"
                [class.hide-transcriptions]="!postToolsConfig['transcriptions']"
              >
              </app-video-player>
            </ng-container>

            <!-- Image Attachment -->
            <ng-container *ngSwitchCase="'image'">
              <img
                [src]="attachment.image_src"
                appFallbackImage
                [containerLevelsUp]="1"
                (click)="openGallery()"
              />

              <!--
          <a *ngIf="attachment.downloadable" [href]="attachment.href" download>Download</a>
          -->
            </ng-container>

            <!-- Article Attachment -->
            <ng-container *ngSwitchCase="'article'">
              <div class="article-attachment">
                <a [href]="attachment?.link" target="_blank">{{
                  attachment?.title
                }}</a>
                <span class="descritpion"> {{ attachment?.description }} </span>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </ng-container>
    </div>

    <div class="card-footer">
      <div class="source">
        <a [href]="post.source.url" target="_blank">
          <img
            [src]="post.source.icon_url"
            appFallbackImage
            [loadingImage]="loadingImage"
            appLazyLoad
          />
          <span class="source-title" [suiTooltip]="post.source.title">{{
            sourceTitle
          }}</span>
        </a>
        <fa-icon
          *ngIf="
            userFacade.hasPermissionSync(
              AppComponents.FEED_SEARCH_RESULTS_REMOVE_SOURCE_FROM_FEED
            ) &&
            !disableTools &&
            !isShadow
          "
          [icon]="['fas', 'ban']"
          (click)="removeSourcePosts(post.source)"
          [suiTooltip]="
            'post-card.tooltip.remove-posts-from-this-source' | translate
          "
        ></fa-icon>
        <a
          href="{{ debugSourceUrl }}"
          target="_blank"
          *ngIf="
            userFacade.hasPermissionSync(
              AppComponents.FEED_SEARCH_RESULTS_DEBUG_SOURCE
            )
          "
          ><fa-icon [icon]="['fas', 'bug']"></fa-icon
        ></a>
      </div>
      <div class="properties">
        <ng-container *ngFor="let postProperty of postPropertyViewConfig">
          <div class="property">
            <div class="name">{{ postProperty.label }}</div>
            <div class="value" [title]="postProperty.value">
              <fa-icon [icon]="postProperty.icon"></fa-icon>
              {{ postProperty.value | humanizeNumber: 1 }}
            </div>
          </div>
        </ng-container>
      </div>

      <div
        class="feed-categories-holder"
        *ngIf="
          userFacade.hasPermissionSync(
            AppComponents.FEED_SEARCH_RESULTS_SET_CATEGORIES
          ) && feed?.company_categories.length > 0
        "
        #postCategoryTree
      >
        <div (click)="toggleCategoryTree($event)" class="category-tree-toggle">
          <span>{{ companyCategoryNames }}</span>
          <fa-icon
            [icon]="['fas', 'chevron-down']"
            *ngIf="!categoryTreeVisible && !isShadow"
          ></fa-icon>
          <fa-icon
            [icon]="['fas', 'chevron-up']"
            *ngIf="categoryTreeVisible"
          ></fa-icon>
        </div>

        <app-post-category-tree
          *ngIf="categoryTreeVisible"
          [selectedCategories]="post?.user_categories"
          [postId]="post.id"
          (requestClose)="categoryTreeVisible = false"
        ></app-post-category-tree>
      </div>
    </div>

    <div
      class="card-footer-tools"
      *ngIf="
        allowRelatedPosts &&
        (post.post_parent_related_count > 0 ||
          post.post_child_related_count > 0)
      "
      [ngClass]="{ parent: post.post_child_related_count > 0 }"
    >
      <i class="mdi mdi-link"></i>
      <span *ngIf="post.post_child_related_count > 0">
        {{
          "post-card.footer.message.this-article-is-parent-of-count-related-articles"
            | translate: { related_count: post.post_child_related_count }
        }}
      </span>
      <span
        *ngIf="
          post.post_parent_related_count > 0 &&
          post.post_child_related_count === 0
        "
      >
        {{
          "post-card.footer.message.this-article-is-related-to-another-article"
            | translate
        }}
      </span>
      <span class="edit-related" (click)="editRelated()">{{
        "post-card.footer.show-more" | translate
      }}</span>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="viewMode == 'gallery'">
  <div class="post-card gallery" [ngClass]="{ selected: post.selected }">
    <div class="card-header" *ngIf="!disableTools">
      <div class="card-info">
        <div
          class="select-tool"
          (click)="togglePostSelect()"
          *ngIf="isSelectable"
        >
          <sui-checkbox [checked]="post.selected"></sui-checkbox>
        </div>
        <div class="post-type">
          <fa-icon [icon]="['fas', 'earth']"></fa-icon>
        </div>

        <!-- Take sentiment_id from the first element in post_sentiment_algorithm_list and use it as div class for sentiment
        sentiment_id 1 is neutral, 2 is positive, 3 is negative
        for text, use the "title" from the first element in post_sentiment_algorithm_list -->

        <div>
          <div
            [suiMenuTrigger]="sentimentMenu2"
            [suiMenuTriggerDisabled]="isShadow"
            class="sentiment {{
              sentimentClassMap[
                post.post_sentiment_algorithm_list[0].sentiment_id
              ] ?? 'neutral'
            }}"
          >
            {{ post.post_sentiment_algorithm_list[0].title }}
          </div>
          <ng-template #sentimentMenu2>
            <sui-menu>
              <button
                sui-menu-item
                (click)="setSentiment(NomSentiment.NEGATIVE)"
              >
                <fa-icon [icon]="['fas', 'face-frown']"></fa-icon>
                <span>{{
                  "post-card.dropdown-item.negative" | translate
                }}</span>
              </button>
              <button
                sui-menu-item
                (click)="setSentiment(NomSentiment.NEUTRAL)"
              >
                <fa-icon [icon]="['fas', 'face-meh']"></fa-icon>
                <span>{{ "post-card.dropdown-item.neutral" | translate }}</span>
              </button>
              <button
                sui-menu-item
                (click)="setSentiment(NomSentiment.POSITIVE)"
              >
                <fa-icon [icon]="['fas', 'smile']"></fa-icon>
                <span>{{
                  "post-card.dropdown-item.positive" | translate
                }}</span>
              </button>
            </sui-menu>
          </ng-template>
        </div>
        <div class="post-date" [ngSwitch]="timeShown">
          <ng-container *ngSwitchCase="'post_time_published_relative'">
            {{ post.publish_time.relative }}
          </ng-container>

          <ng-container *ngSwitchCase="'post_time_published_absolute'">
            {{ post.publish_time.absolute | date: "dd.MM.yy HH:mm" }}
          </ng-container>

          <ng-container *ngSwitchCase="'post_time_created_relative'">
            {{ post.created_time.relative }}
          </ng-container>

          <ng-container *ngSwitchCase="'post_time_created_absolute'">
            {{ post.created_time.absolute | date: "dd.MM.yy HH:mm" }}
          </ng-container>
        </div>

        <div
          class="completeness-score"
          [class.low]="post.completeness_score <= 25"
          [class.medium]="
            post.completeness_score > 25 && post.completeness_score <= 75
          "
          [class.high]="post.completeness_score > 75"
          *ngIf="user?.access_level_id >= UserAccessLevel.GLOBAL_ADMIN"
        >
          <fa-icon [icon]="scoreIcon"></fa-icon>
          <span>{{ post.completeness_score }}</span>
        </div>
        <div
          class="has-synopsis"
          *ngIf="
            post.has_synopsis &&
            userFacade.hasPermissionSync(
              AppComponents.POST_DETAILS_PANE_SYNOPSIS_EDITOR
            )
          "
          [suiTooltip]="'post-card.tooltip.has-synopsis' | translate"
        >
          <fa-icon [icon]="['fas', 'clipboard-list']"></fa-icon>
        </div>
        <div
          class="has-trancription"
          *ngIf="post.has_transcription"
          [suiTooltip]="'post-card.tooltip.has-transcription' | translate"
        >
          <fa-icon [icon]="['fas', 'message']"></fa-icon>
        </div>
        <div
          class="has-screen-capture"
          *ngIf="hasScreenCapture"
          [suiTooltip]="'post-card.tooltip.has-screen-capture' | translate"
        >
          <fa-icon [icon]="['fas', 'camera']"></fa-icon>
        </div>
      </div>
      <div class="card-tools">
        <div class="card-tool">
          <a
            [suiTooltip]="'post-card.tooltip.view-details' | translate"
            (click)="toggleDetails()"
            ><fa-icon [icon]="['fas', 'eye']"></fa-icon
          ></a>
        </div>
        <div class="card-tool" *ngIf="!isShadow">
          <a
            [suiTooltip]="'post-card.tooltip.edit-categories' | translate"
            (click)="editCategories()"
            ><fa-icon [icon]="['fas', 'tag']"></fa-icon
          ></a>
        </div>
        <div class="card-tool" *ngIf="!isShadow">
          <sui-button
            size="sm"
            variant="ghost"
            [leadingIcon]="['fas', 'bars']"
            [trailingIcon]="['fas', 'caret-down']"
            [iconOnly]="true"
            ariaLabel="Algorithms"
            [expanded]="postAlgorithmsRef2.isOpen()"
            [suiMenuTrigger]="algorithmsMenu2"
            #postAlgorithmsRef2="suiMenu"
          ></sui-button>
          <ng-template #algorithmsMenu2>
            <sui-menu>
              <ng-container *ngFor="let item of algorithms; let i = index">
                <sui-menu-separator
                  *ngIf="
                    i > 0 && algorithms[i].group !== algorithms[i - 1].group
                  "
                ></sui-menu-separator>
                <button sui-menu-item (click)="runAlgorithm(item)">
                  <fa-icon *ngIf="item.icon" [icon]="item.icon"></fa-icon>
                  <span>{{ item?.name }}</span>
                </button>
              </ng-container>
            </sui-menu>
          </ng-template>
        </div>
        <div
          *ngIf="loadingAlgorithmPostIds?.includes(post.id)"
          class="loading-post-algorithm"
        >
          <fa-icon [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
        </div>
        <div
          *ngIf="appliedAlgorithmPostIds?.includes(post.id)"
          class="applied-post-algorithm"
          [suiTooltip]="'post-card.tooltip.applied-algorithm' | translate"
        >
          <fa-icon [icon]="['fas', 'square-check']"></fa-icon>
        </div>
        <div
          class="card-tool remove-post"
          *ngIf="removable && !disableTools && !isShadow"
        >
          <a
            [suiTooltip]="'post-card.tooltip.remove-post' | translate"
            (click)="removeFromFeed()"
            ><fa-icon [icon]="['far', 'times-circle']"></fa-icon
          ></a>
        </div>
        <div class="card-tool remove-post" *ngIf="customRemovePost">
          <a
            [suiTooltip]="'post-card.tooltip.remove-post' | translate"
            (click)="customRemovePost(post); $event.stopPropagation()"
            ><fa-icon [icon]="['far', 'times-circle']"></fa-icon
          ></a>
        </div>
      </div>
    </div>

    <div class="card-body" (click)="togglePostSelect()">
      <div class="author" *ngIf="post.type === 'social'">
        <div class="avatar" *ngIf="post.author?.avatar_url">
          <a
            *ngIf="post.author.profile_url"
            [href]="post.author.profile_url"
            target="_blank"
          >
            <img
              [src]="post.author.avatar_url"
              [appFallbackImage]="avatarFallback"
              appLazyLoad
              class="post-avatar"
            />
          </a>
          <img
            *ngIf="!post.author.profile_url"
            [src]="post.author.avatar_url"
            [appFallbackImage]="avatarFallback"
            appLazyLoad
            class="post-avatar"
          />
        </div>

        <div class="author-info" *ngIf="post.author as author">
          <!-- Author Name -->
          <a
            *ngIf="author.profile_url"
            [href]="author.profile_url"
            target="_blank"
            class="author-name"
          >
            {{ author.name }}
          </a>
          <span *ngIf="!author.profile_url" class="author-name">
            {{ author.name }}
          </span>

          <!-- Author Handle -->
          <ng-container *ngIf="author.username">
            <a
              *ngIf="author.profile_url"
              [href]="author.profile_url"
              target="_blank"
              class="author-handle"
            >
              {{ "@" + author.username }}
            </a>
            <span *ngIf="!author.profile_url" class="author-handle">
              {{ "@" + author.username }}
            </span>
          </ng-container>
        </div>
      </div>
      <a
        [href]="post.type === 'social' ? post.url : null"
        target="_blank"
        (click)="$event.stopPropagation()"
        class="thumbnail"
        *ngIf="post.thumbnail_big"
      >
        <img
          [src]="post.thumbnail_big"
          appFallbackImage
          [loadingImage]="loadingImage"
          (imageLoaded)="onImageLoaded()"
          appLazyLoad
          class="post-thumbnail"
        />
      </a>
      <div class="card-content">
        <a
          class="title"
          [innerHTML]="post.title"
          [href]="post.url"
          target="_blank"
          (click)="$event.stopPropagation()"
        ></a>

        <a
          [attr.href]="post.type === 'social' ? post.url : null"
          target="_blank"
          (click)="$event.stopPropagation()"
          class="content"
          [innerHTML]="post.content"
          *ngIf="postPropertyConfig['content']"
        ></a>
        <div class="user-categories" *ngIf="post.user_categories.length > 0">
          <span class="categories-title">{{
            "post-card.label.categories" | translate
          }}</span>
          <span
            class="user-category"
            *ngFor="let category of post.user_categories; trackBy: trackById"
            (click)="editCategories()"
          >
            <fa-icon [icon]="['fas', 'tag']"></fa-icon>
            {{ category.name }}</span
          >
        </div>
        <div
          class="workflows"
          *ngIf="
            userFacade.hasPermissionSync(
              AppComponents.FEED_SEARCH_RESULTS_EDIT_WORKFLOW
            ) && workflowStages?.length > 0
          "
        >
          <span class="workflows-title">{{
            "post-card.label.workflows" | translate
          }}</span>
          <div
            *ngFor="let stage of workflowStages"
            class="workflow-stage"
            [ngClass]="{
              active: stage.is_current,
              clickable: stage.enabled && !isShadow,
            }"
            (click)="
              stage.enabled && !isShadow ? changeWorkflowStage(stage) : null
            "
          >
            <fa-icon
              [icon]="['fas', 'backward-step']"
              *ngIf="stage.is_previous"
            ></fa-icon>
            {{ stage.name }}
            <fa-icon
              [icon]="['fas', 'forward-step']"
              *ngIf="stage.is_next"
            ></fa-icon>
          </div>
        </div>
      </div>
    </div>
    <div class="attachments" *ngIf="post.attachments?.length > 0">
      <ng-container *ngFor="let attachment of post.attachments; let i = index">
        <div
          *ngIf="!(attachment.is_thumbnail && attachment.type == 'image')"
          class="attachment

        {{ attachment.type }}"
        >
          <ng-container [ngSwitch]="attachment.type">
            <!-- Video Attachment -->
            <ng-container *ngSwitchCase="'video'">
              <app-video-player
                [attachment]="attachment"
                [postId]="post.id"
                [attachmentId]="post.id + '-' + i"
                [postTypeId]="post.post_type_id"
                [contentProviderId]="post.content_provider.id"
                [autoplay]="false"
                [class.hide-transcriptions]="!postToolsConfig['transcriptions']"
              >
              </app-video-player>
            </ng-container>

            <!-- Image Attachment -->
            <ng-container *ngSwitchCase="'image'">
              <img
                [src]="attachment.image_src"
                appFallbackImage
                [containerLevelsUp]="1"
                (click)="openGallery()"
              />

              <!--
          <a *ngIf="attachment.downloadable" [href]="attachment.href" download>Download</a>
          -->
            </ng-container>

            <!-- Article Attachment -->
            <ng-container *ngSwitchCase="'article'">
              <div class="article-attachment">
                <a [href]="attachment?.link" target="_blank">{{
                  attachment?.title
                }}</a>
                <span class="descritpion"> {{ attachment?.description }} </span>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </ng-container>
    </div>
    <div class="card-footer">
      <div class="source">
        <a [href]="post.source.url" target="_blank">
          <img
            [src]="post.source.icon_url"
            appFallbackImage
            [loadingImage]="loadingImage"
            appLazyLoad
          />
          {{ sourceTitle }}
        </a>
      </div>
      <div class="properties">
        <ng-container *ngFor="let postProperty of postPropertyViewConfig">
          <div class="property" *ngIf="postProperty.value">
            <div class="name">{{ postProperty.label }}</div>
            <div class="value">
              <fa-icon [icon]="postProperty.icon"></fa-icon>
              {{ postProperty.value }}
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="viewMode == 'compact'">
  <div
    class="post-card-compact item"
    [class.expanded]="compactExpanded"
    [class.sortable]="sortable"
    [style.background]="post.color_bg"
  >
    <div class="compact-row">
      @if (sortable) {
        <div
          class="drag-handle"
          cdkDragHandle
          [suiTooltip]="'post-card.tooltip.drag-to-reorder' | translate"
          [attr.aria-label]="'post-card.tooltip.drag-to-reorder' | translate"
        >
          <fa-icon [icon]="['fas', 'grip-vertical']"></fa-icon>
        </div>
      }
      <div class="tools switch-parent">
        <div
          class="parent"
          (click)="togglePostParentCard(post)"
          [suiTooltip]="
            'post-card.tooltip.select-this-post-as-post-parent' | translate
          "
        >
          P
        </div>
      </div>

      <div class="source">
        <div class="icon">
          <img [src]="post.source.icon_url" width="24" height="24" />
        </div>
        <div class="title">
          {{ sourceTitle }}
        </div>
      </div>
      <div class="avatar" *ngIf="post.type === 'social'">
        <img
          *ngIf="post.author?.avatar_url"
          [src]="post.author?.avatar_url"
          [appFallbackImage]="avatarFallback"
          appLazyLoad
          class="post-avatar"
        />
      </div>
      <div
        class="title"
        [innerHTML]="postCompactContent"
        [title]="postCompactContent"
      ></div>
      <button
        type="button"
        class="toggle-expand"
        (click)="compactExpanded = !compactExpanded"
        [suiTooltip]="
          (compactExpanded
            ? 'post-card.tooltip.collapse-post-content'
            : 'post-card.tooltip.expand-post-content'
          ) | translate
        "
      >
        <fa-icon
          [icon]="['fas', compactExpanded ? 'chevron-up' : 'chevron-down']"
        ></fa-icon>
      </button>
      <a
        class="open-post"
        [href]="post.url"
        target="_blank"
        rel="noopener"
        [suiTooltip]="'post-card.tooltip.open-post-in-new-tab' | translate"
      >
        <fa-icon [icon]="['fas', 'arrow-up-right-from-square']"></fa-icon>
      </a>

      <div class="tools select">
        <div
          class="remove"
          (click)="togglePostSelect()"
          [suiTooltip]="
            'post-card.tooltip.remove-post-from-current-selected-list'
              | translate
          "
        >
          <fa-icon [icon]="['far', 'times-circle']"></fa-icon>
        </div>
      </div>
    </div>
    @if (compactExpanded) {
      <div class="expanded-content" [innerHTML]="post.content"></div>
    }
  </div>
</ng-container>

<!-- Story mode view -->
<ng-container *ngIf="viewMode == 'default' && isStoryMode">
  <div
    class="post-card story-card"
    #card
    [ngClass]="{
      selected: post.selected,
      highlighted: highlighted,
    }"
    (click)="toggleDetails()"
  >
    <div class="card-header">
      <div class="card-info">
        <div class="post-type" *ngIf="post.icon">
          <fa-icon [icon]="post.icon"></fa-icon>
        </div>
        <div
          class="sentiment {{
            sentimentClassMap[
              post.post_sentiment_algorithm_list[0]?.sentiment_id
            ] ?? 'neutral'
          }}"
          *ngIf="
            postToolsConfig['sentiment'] &&
            post.post_sentiment_algorithm_list[0] as sentiment
          "
        >
          {{ sentiment.title }}
        </div>

        <div class="post-date" [ngSwitch]="timeShown">
          <ng-container *ngSwitchCase="'post_time_published_relative'">
            {{ post.publish_time.relative }}
          </ng-container>

          <ng-container *ngSwitchCase="'post_time_published_absolute'">
            {{ post.publish_time.absolute | date: "dd.MM.yy HH:mm" }}
          </ng-container>

          <ng-container *ngSwitchCase="'post_time_created_relative'">
            {{ post.created_time.relative }}
          </ng-container>

          <ng-container *ngSwitchCase="'post_time_created_absolute'">
            {{ post.created_time.absolute | date: "dd.MM.yy HH:mm" }}
          </ng-container>
        </div>
      </div>

      <div class="card-tools">
        <div
          class="card-tool"
          *ngIf="!disableTools && postToolsConfig['view-details']"
        >
          <a
            [suiTooltip]="'post-card.tooltip.view-details' | translate"
            (click)="toggleDetails(); $event.stopPropagation()"
            ><fa-icon [icon]="['fas', 'eye']"></fa-icon
          ></a>
        </div>
      </div>
    </div>

    <div class="story-card-body">
      <a
        class="thumbnail"
        *ngIf="post.thumbnail"
        [href]="post.url"
        target="_blank"
        (click)="$event.stopPropagation()"
      >
        <img
          [src]="post.thumbnail"
          appFallbackImage
          [loadingImage]="loadingImage"
          [containerLevelsUp]="1"
          appLazyLoad
          class="post-thumbnail"
        />
      </a>
      <div class="story-card-content">
        <a
          class="title"
          [innerHTML]="post.title"
          [href]="post.url"
          target="_blank"
          (click)="$event.stopPropagation()"
        ></a>
        <span
          class="content"
          [innerHTML]="post.content"
          *ngIf="postPropertyConfig['content']"
        ></span>
      </div>
    </div>

    <div class="story-card-footer" *ngIf="postPropertyViewConfig.length > 0">
      <div class="properties">
        <ng-container *ngFor="let postProperty of postPropertyViewConfig">
          <div class="property">
            <div class="name">{{ postProperty.label }}</div>
            <div class="value" [title]="postProperty.value">
              <fa-icon [icon]="postProperty.icon"></fa-icon>
              {{ postProperty.value | humanizeNumber: 1 }}
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</ng-container>
